import React, { FunctionComponent, Fragment } from "react";
import DictionaryProps from "./DictionaryProps.interface";

import { useSelector } from "react-redux";

const Dictionary: FunctionComponent<DictionaryProps> = (props) => {
    const translations = useSelector(state => state.dictionary.translations);
    const fallback = props.name;

    return (
        <Fragment>{translations && translations[props.name] ? translations[props.name] : fallback}</Fragment>
    );
};

export default Dictionary;